import "./button.css"

import { ButtonHTMLAttributes, PropsWithChildren, Ref } from "react"

import { FOCUS_OUTLINE_CLASS } from "@/theme"
import { join } from "@/utils/join"

interface Props {
  variant: "brand" | "primary" | "warning" | "outline"
  size: "2xs" | "xs" | "sm" | "lg"
  ref?: Ref<HTMLButtonElement>
}

export const Button = ({
  children,
  className,
  ref,
  variant,
  size,
  ...props
}: PropsWithChildren<Props & ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const enabledClasses = "cursor-pointer active:translate-y-[1px]"

  const baseClass = "px-md rounded-full  text-nowrap"

  const sizeClasses = {
    "2xs": "h-[18px] px-sm",
    xs: "density-xs",
    sm: "density-sm",
    lg: "density-md",
  }
  const sizeClass = sizeClasses[size] || sizeClasses.sm

  // Use only the CSS classes for variants
  const variantClass = props.disabled ? "button_disabled" : `button_${variant}`

  const buttonClass = join(
    baseClass,
    FOCUS_OUTLINE_CLASS,
    sizeClass,
    variantClass,
    props.disabled || enabledClasses,
    className ?? "",
  )
  return (
    <button className={buttonClass} ref={ref} {...props}>
      <div className={size === "2xs" ? "text-2xs-regular" : "text-sm-semibold"}>
        {children}
      </div>
    </button>
  )
}
